import { useEffect, useState, useRef } from "react"

import PlusIcon from "../../../../../assets/icons/PlusIcons"
import Button from "../../../../atoms/Button"
import Select from "../../../../atoms/Select"
import Input from "../../../../atoms/Input"
import SwitchComponent from "../../../../atoms/Switch"
import styles from "./index.module.scss"
import { unitLocal } from "../../../../../services/local"
import { set, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { schemaAddEquipament } from "../../yup/schemaValidation"
import RcmpLoading from "../../../../atoms/Loading"
import { ModalInformation } from "../ModalInformation"
import { useNavigate } from "react-router-dom"
import { createEquipament } from "../../../../../services/ciq"
import SaveIcon from "../../../../../assets/icons/SaveIcon"
import { toast } from "@stardust-ds/react"
import intl from "react-intl-universal"
import { SectorSelect } from "../SectorSelect"

export const FormAddEquipaments = ({
  children,
  setBisOpenModal,
  equipment_analytes,
  analytesVinculatedWithEquipment,
}) => {
  const [optsUnit, setOptsUnit] = useState([])
  const [isChecked, setChecked] = useState(true)
  const [isLoadPage, setIsLoadPage] = useState(false)
  const [isLoadingBtn, setIsLoadingBtn] = useState(false)
  const [isCancelModal, setIsCancelModal] = useState(false)
  const navigate = useNavigate()
  const {
    register,
    handleSubmit,
    setValue,
    setError,
    trigger,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schemaAddEquipament),
  })

  const firstErrorRef = useRef(null);

  const handleScrollToErrorField = () => {
    if (firstErrorRef.current) {
      firstErrorRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  useEffect(() => {
    handleScrollToErrorField()
  }, [errors]);

  const submitCreateEquipament = async (data) => {
    try {
      setIsLoadingBtn(true)

      const equipment_bstatus = !data.anlt_bstatus ? isChecked : data.anlt_bstatus
      const newData = {
        equipment_casset_number: data.equipment_casset_number,
        equipment_cmanufacturer: data.equipment_cmanufacturer.trim(),
        equipment_cname: data.equipment_cname.trim(),
        equipment_cobservation: data.equipment_cobservation.trim(),
        equipment_cserial_number: data.equipment_cserial_number.trim(),
        equipment_unit_nid: data.equipment_unit_nid,
        equipment_sector_nid: data.equipment_sector_nid,
        equipment_bstatus,
        equipment_analytes: equipment_analytes
          .concat(analytesVinculatedWithEquipment)
          .map((item) => {
            return {
              ...item,
              eqpanlt_bstatus:
                item.eqpanlt_bstatus === "Active" ||
                item.eqpanlt_bstatus === "Ativo" ||
                item.eqpanlt_bstatus === true
                  ? true
                  : false,
            }
          }),
      }

      await createEquipament(newData)
      setIsLoadingBtn(false)
      redirect()
    } catch (err) {
      console.error(err)
      fnOpenToastFail(err.response?.data.message)
    } finally {
      setIsLoadingBtn(false)
    }
  }

  function fnOpenToastFail(message) {
    return toast({
      type: "error",
      title: "Erro",
      description: message,
    })
  }

  const getUnit = async () => {
    try {
      setIsLoadPage(true)
      const response = await unitLocal()

      setOptsUnit(
        response.data.map((item) => ({
          label: item.locl_cfantasyname,
          value: item.locl_nid,
        })),
      )
      setIsLoadPage(false)
    } catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    getUnit()
  }, [])

  const fnIsError = (message) => {
    return message?.message ? styles.error : ""
  }

  const redirect = () => {
    setIsCancelModal(false)
    navigate("/ciq/list-equipments")
  }

  return (
    <>
      {isLoadPage ? (
        <div className={styles.flexCenter} style={{}}>
          <RcmpLoading bShow={true} />
        </div>
      ) : (
        <form
          className={styles.formEquipaments}
          onSubmit={handleSubmit(submitCreateEquipament)}
          autoComplete="off"
        >
          <div className={styles.flexLine}>
            <h2 className={styles.titlePage}>{intl.get("ciq.equipment_data")}</h2>

            <div className={styles.containerSwitch}>
              <label>{intl.get("ciq.header_table_list_analyte.status")}</label>
              <SwitchComponent
                width="10rem"
                label="Status"
                onClick={() => {
                  setChecked((oldState) => !oldState)
                  setValue("equipment_bstatus", !isChecked)
                }}
                cDisabledText={intl.get("ciq.inactive_up")}
                cAbleText={intl.get("ciq.active_up")}
                value={isChecked}
              />
            </div>
          </div>

          <div className={styles.flexLine}>
            <div className={`${styles.itemFlex} ${styles.thirtyPercent} ${fnIsError(errors?.equipment_cname)}`}>
              <Input
                label={intl.get("ciq.header_table_list_equipment.name") + "*"}
                width="100%"
                {...register("equipment_cname")}
              />
              {fnIsError(errors?.equipment_cname) && (
                <span ref={firstErrorRef}>{errors?.equipment_cname?.message}</span>
              )}
            </div>
            <div className={`${styles.itemFlex} ${styles.thirtyPercent}`}>
              <Input
                label={intl.get("ciq.header_table_list_equipment.manufacture")}
                width="100%"
                {...register("equipment_cmanufacturer")}
              />
            </div>
            <div
              className={`${styles.itemFlex} ${styles.thirtyPercent} 
                ${fnIsError(errors?.equipment_cserial_number)}`}
            >
              <Input
                label={intl.get("ciq.serial_number") + "*"}
                width="100%"
                {...register("equipment_cserial_number")}
              />

              {fnIsError(errors?.equipment_cserial_number) && (
                <span ref={firstErrorRef}>{errors?.equipment_cserial_number?.message}</span>
              )}
            </div>
          </div>

          <div>
            <div className={styles.flexLine}>
              <div className={`${styles.itemFlex} ${styles.thirtyPercent}`}>
                <Input
                  label={intl.get("ciq.header_table_list_equipment.patrimony")}
                  width="100%"
                  {...register("equipment_casset_number")}
                />
              </div>

              <div
                className={`${styles.itemFlex} ${styles.thirtyPercent}
               ${fnIsError(errors?.equipment_unit_nid)}      `}
              >
                <Select
                  className={styles.select}
                  label={intl.get("unit") + "*"}
                  width="100%"
                  options={optsUnit}
                  defaultValue={optsUnit[0]}
                  searchable={false}
                  placeholder={intl.get("select_unit")}
                  onSelect={(itemSelected) => {
                    if (itemSelected === null) {
                      setValue("equipment_unit_nid", null)
                    } else {
                      setValue("equipment_unit_nid", itemSelected?.value)
                      setError("equipment_unit_nid", {
                        type: "manual",
                        message: "",
                      })
                    }
                  }}
                />

                {fnIsError(errors?.equipment_unit_nid) && (
                  <span ref={firstErrorRef}>{errors?.equipment_unit_nid?.message}</span>
                )}
              </div>
              <div className={`${styles.itemFlex} ${styles.thirtyPercent} ${styles.sectorField}`}>
                <SectorSelect
                  label={intl.get("ciq.header_table_list_analyte.sector") + "*"}
                  placeholder={intl.get("ciq.select_one_sector")}
                  onSelect={(e) => {
                    setValue("equipment_sector_nid", e.map((item) => item.id)[0])
                    trigger("equipment_sector_nid")
                  }}
                  isError={fnIsError(errors?.equipment_sector_nid)}
                  messageError={errors?.equipment_sector_nid?.message}
                  bIsEdit={false}
                />
                {fnIsError(errors?.equipment_sector_nid) && (
                  <span ref={firstErrorRef} />
                )}
              </div>
            </div>
            <div className={styles.itemFlex} style={{ marginTop: 8 }}>
              <Input
                label={intl.get("ciq.observations")}
                width="100%"
                {...register("equipment_cobservation")}
              />
            </div>
          </div>

          <div className={styles.flexLine} style={{ marginTop: "1rem" }}>
            <h2 className={styles.titlePage}>
              {intl.get("ciq.list_analytes.exame_analyte")}
            </h2>

            <div className={styles.containerButton}>
              <Button
                type="button"
                variant="outline"
                onClick={() => {
                  setBisOpenModal(true)
                }}
              >
                <PlusIcon className={styles.plusIcon} />
                {intl.get("ciq.list_analytes.add_exame_analyte")}
              </Button>
            </div>
          </div>

          {children}

          <div className={styles.flexLine} style={{ marginTop: "1rem" }}>
            <div className={styles.containerButton}>
              <Button
                variant="outline"
                type="button"
                onClick={() => {
                  setIsCancelModal(true)
                }}
              >
                {intl.get("ciq.btn_cancel")}
              </Button>
            </div>

            <div className={styles.containerButton}>
              <Button type="submit" isLoading={isLoadingBtn}>
                <SaveIcon />
                {intl.get("ciq.save_equipment")}
              </Button>
            </div>
          </div>
        </form>
      )}

      {isCancelModal && (
        <ModalInformation
          bgBtn="#1ECB4F"
          bShow={isCancelModal}
          title={intl.get("ciq.add_equipment") + "s"}
          description={intl.get("ciq.changes_not_save")}
          onClose={() => redirect()}
          onCancel={() => setIsCancelModal(false)}
        />
      )}
    </>
  )
}
